var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center w-full h-full"},[_c('div',[((_vm.campaigns.length > 0))?_c('h4',[_vm._v(" Select a campaign ")]):_c('h4',[_vm._v(" No campaings ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }